import { render } from "./PasswordStrengthIndicator.vue?vue&type=template&id=473700a5&scoped=true"
import script from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js"
export * from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js"

import "./PasswordStrengthIndicator.vue?vue&type=style&index=0&id=473700a5&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473700a5"]])

export default __exports__